import { createStore } from 'vuex'

//const debug = process.env.NODE_ENV !== 'production'

const store = createStore({
  state: {

  },

  mutations: {

  },

  actions: {
    routeChanged ({ dispatch }) {
      dispatch('menu/closeMenu')
    }
  },

  modules: {
  },

  strict: false
})

export function useContext (requireContext) {
  const modulesFiles = requireContext.keys();

  return modulesFiles.map(filePath => {
    const moduleName = filePath.split('/').pop().replace(/\.js$/, '')
    const moduleExport = requireContext(filePath)
    store.registerModule(moduleName, moduleExport.default || moduleExport)
  })
}

useContext(require.context(
  // root folder for components
  './modules/',
  // recursive
  true,
  // include all .js wo index.js
  /\/.*\.js$/,
))

export default store;
